<!-- Ad Campaigns -->
<lib-ad-sponsor-banner
  *ngIf="entityId"
  [entityId]="entityId"
  [entityType]="type"
  [hideHeader]="true">
</lib-ad-sponsor-banner>
<!-- Team Filter -->
<lib-picker-slider
  *ngIf="topTeams"
  [items]="topTeams"
  [colorScheme]="colorScheme"
  (onSelect)="onItemSelect($event)">
</lib-picker-slider>
<div class="spinner-container {{colorScheme.main}}" *ngIf="isLoading">
  <mat-spinner strokeWidth="2" color="accent" diameter="54" class="m-auto"></mat-spinner>
</div>
<div class="content-container"
     *ngIf="selectedItem"
     [style.opacity]="isLoading ? '0' : '1'">
  <!-- Matches -->
  <lib-match-section
    moreButtonTitle="Mehr Spiele"
    moreButtonRouterLink="/spiele"
    [layout]="MatchLayout.Minimal"
    [live]="true"
    [matches]="events"
  ></lib-match-section>

  <!-- Has Videos -->
  <ng-container *ngIf="showVideoContent; else noNativeVideos">
    <!-- Video News -->
    <lib-news-section
      title="Im Fokus"
      titleIcon="whatshot"
      moreButtonRouterLink="/news"
      [newsList]="editorialNews"
      [layout]="NewsLayout.Mixed"
      [colorScheme]="colorScheme">
    </lib-news-section>
    <lib-ad class="ad"></lib-ad>
    <!-- Table -->
    <div class="table-container" *ngIf="leagueForTable">
      <lib-section-header
        title="Tabelle"
        titleIcon="emoji_events"
      ></lib-section-header>
      <lib-league-table
        [canExpand]="true"
        [league]="leagueForTable"
        [highlightTeamId]="selectedItem.objectId"
        [rowLimit]="6"
        [showHeader]="false">
      </lib-league-table>
    </div>
    <!-- Replays -->
    <lib-match-section
      title="Nachschauen"
      titleIcon="replay"
      moreButtonTitle="Mehr Replays"
      moreButtonRouterLink="/replays"
      [matches]="replays"
      [colorScheme]="colorScheme"
    ></lib-match-section>
    <!-- Abo Banner -->
    <lib-abo-banner [name]="bannerName" [user]="user"></lib-abo-banner>
    <!-- Other News -->
    <lib-news-section
      title="Aktuelles"
      titleIcon="newspaper"
      [newsList]="otherNews"
      [layout]="NewsLayout.Row"
      [colorScheme]="colorScheme"
      moreButtonRouterLink="/news">
    </lib-news-section>
    <!-- Main News -->
    <lib-news-section
      title="Team-News"
      titleIcon="newspaper"
      moreButtonRouterLink="/news"
      [newsList]="news"
      [layout]="NewsLayout.Mixed"
      [colorScheme]="colorScheme">
    </lib-news-section>
  </ng-container>

  <!-- No Videos -->
  <ng-template #noNativeVideos>
    <!-- Main News -->
    <lib-news-section
      title="Im Fokus"
      titleIcon="whatshot"
      moreButtonRouterLink="/news"
      [newsList]="news"
      [layout]="NewsLayout.Mixed"
      [colorScheme]="colorScheme">
    </lib-news-section>
    <lib-ad class="ad"></lib-ad>
    <!-- Table -->
    <div class="table-container" *ngIf="leagueForTable">
      <lib-section-header
        title="Tabelle"
        titleIcon="emoji_events"
      ></lib-section-header>
      <lib-league-table
        [canExpand]="true"
        [league]="leagueForTable"
        [highlightTeamId]="selectedItem.objectId"
        [rowLimit]="6"
        [showHeader]="false">
      </lib-league-table>
    </div>
    <!-- Other News -->
    <lib-news-section
      title="Aktuelles"
      titleIcon="newspaper"
      [newsList]="otherNews"
      [layout]="NewsLayout.Row"
      [colorScheme]="colorScheme"
      moreButtonRouterLink="/news">
    </lib-news-section>
    <!-- Default Videos -->
    <lib-news-section
      *ngIf="news.length > 0"
      title="Videos"
      titleIcon="play_circle"
      moreButtonRouterLink="/news"
      [newsList]="news"
      [layout]="NewsLayout.Row"
      [colorScheme]="colorScheme">
    </lib-news-section>
  </ng-template>
</div>
